(() => {
  const openTarget = (hash) => {
    if (!hash || hash === '#') return;

    let target;
    try {
      target = document.querySelector(hash);
    } catch {
      return;
    }
    if (!target?.matches?.('details[data-size-page-guide]')) return;
    target.open = true;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-size-page-guide-link]');
    if (link) openTarget(link.hash);
  });

  openTarget(globalThis.location?.hash);
  globalThis.addEventListener?.('hashchange', () => openTarget(globalThis.location?.hash));
})();
